// One shared query for the integrations aggregate - the topbar pill,
// the /settings/integrations page and the Gmail tile must read the same
// answer, not race their own fetches.

import { useQuery } from "@tanstack/react-query";
import { fetchIntegrationsStatus } from "../api/integrations";

export function useIntegrationsStatus() {
  return useQuery({
    queryKey: ["integrations", "status"],
    queryFn: fetchIntegrationsStatus,
    staleTime: 60_000,
    retry: false,
  });
}
